module.exports = __webpack_public_path__ + "static/CanadaFlag-d0ba867695a873a227a4861d88cee766.png";